import React from 'react';
import './PaymentCrisisSection.css';

const PaymentCrisisSection: React.FC = () => {
  return (
    <section className="payment-crisis-section">
      <div className="container">
        <div className="crisis-content">
          <div className="crisis-image">
            <div className="image-container">
              <div className="payment-card">
                <div className="card-chip"></div>
                <div className="card-number">•••• •••• •••• 4321</div>
                <div className="card-holder">BUSINESS OWNER</div>
              </div>
              <div className="laptop-device">
                <div className="laptop-screen">
                  <div className="screen-content">
                    <div className="loading-bars">
                      <div className="bar"></div>
                      <div className="bar"></div>
                      <div className="bar"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="crisis-text">
            <h2 className="highlight">
              The Global B2B Payment Crisis
            </h2>
            <p className="crisis-description">
              Today's international business payments are slow, expensive, and opaque.
            </p>
            <div className="crisis-points">
              <div className="crisis-point">
                <span className="crisis-icon">✗</span>
                <span>3-7 day settlement delays</span>
              </div>
              <div className="crisis-point">
                <span className="crisis-icon">✗</span>
                <span>7%+ in fees</span>
              </div>
              <div className="crisis-point">
                <span className="crisis-icon">✗</span>
                <span>$120B lost annually</span>
              </div>
              <div className="crisis-point">
                <span className="crisis-icon">✗</span>
                <span>Billions excluded from the financial system</span>
              </div>
            </div>
            <p className="solution-text">
              It's time for a better way.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PaymentCrisisSection;
